import { render, staticRenderFns } from "./FPegawaiTable.vue?vue&type=template&id=2ba93ad6&scoped=true"
import script from "./FPegawaiTable.vue?vue&type=script&lang=js"
export * from "./FPegawaiTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba93ad6",
  null
  
)

export default component.exports